import { useState } from 'react'
import { Intro } from './Intro'
import { LawyerSearch } from './LawyerSearch'
import { LearnAboutThisService } from './LearnAboutThisService'
import { MarketingPopUp } from './MarketingPopUp'

const Hero = () => {
  const [marketingTextVisible, setMarketingTextVisible] = useState(false)
  return (
    <div className='relative bg-[#EBF3FF]'>
      {marketingTextVisible && (
        <div className='sm:hidden block absolute inset-0 z-40 bg-white/70 backdrop-blur-sm pointer-events-auto'>
          <div className='relative z-30'>
            <div className='pt-16 sm:pt-24 px-7 md:px-8 xl:px-12 pb-4'>
              <Intro />
            </div>
          </div>
        </div>
      )}
      {/* <MarketingPopUp {...{ marketingTextVisible, setMarketingTextVisible }} /> */}
      <div className='relative z-30'>
        <div className='pt-16 sm:pt-24 px-7 md:px-8 xl:px-12 pb-4'>
          <Intro />
          <div className='relative flex justify-center mt-6'>
            <LawyerSearch />
            <LearnAboutThisService />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
